import { Rules } from "0.Mine/3.Interfaces/Rule";
import { WorkFlow, WorkflowResponse } from "0.Mine/3.Interfaces/workFlow";

import { QlickupActions, useQlickupAPI } from "../APICall";

export const useHandleWorkFlow = () => {
  const { QlickUpAPI } = useQlickupAPI();

  const submitNewWorkflow = async (businessId: number, workflow: WorkFlow) => {
    const response = await QlickUpAPI(
      businessId.toString(),
      "submitnewworkflow",
      workflow,
      "workflow",
      QlickupActions.POST
    );

    console.log(response);

    return response.data as WorkflowResponse;
  };

  const getallWorkFlows = async (businessId: number) => {
    const response = await QlickUpAPI(
      businessId.toString(),
      "getallworkflows",
      null,
      "workflow",
      QlickupActions.GET
    );

    console.log(response);

    return response.data.workflows as WorkflowResponse[];
  };

  const getOneWorkFlow = async (businessId: number, workflowId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        `getworkflow`,
        null,
        "workflow",
        QlickupActions.GET,
        { workflow_id: workflowId }
      );

      console.log(response);

      return response.data as WorkFlow;
    } catch (error) {
      console.error("Error fetching workflow:", error);
      return null;
    }
  };

  const sendOrUpdateRuleKanban = async (
    businessId: number,
    kanbanName: string,
    workflowName: string
  ) => {
    const response = await QlickUpAPI(
      businessId.toString(),
      "sendorupdaterulekanban",
      { kanbanName, workflowName },
      "workflow",
      QlickupActions.POST
    );

    console.log(response);
  };
  const sendOrUpdateRuleStatus = async (
    businessId: number,
    statusName: string,
    workflowName: string
  ) => {
    const response = await QlickUpAPI(
      businessId.toString(),
      "sendorupdateruleStatus",
      { statusName, workflowName },
      "workflow",
      QlickupActions.POST
    );

    console.log(response);
  };
  const getAllRules = async (businessId: number) => {
    const response = await QlickUpAPI(
      businessId.toString(),
      "getallrules",
      null,
      "workflow",
      QlickupActions.GET
    );

    console.log(response);

    return response.data.rules as Rules;
  };
  const deleteWorkFlow = async (businessId: number, workflowId: number) => {
    const response = await QlickUpAPI(
      businessId.toString(),
      "deleteworkflow",
      null,
      "workflow",
      QlickupActions.POST,
      { workflow_id: workflowId }
    );

    console.log(response);
  };
  const deleteRule = async (businessId: number, ruleId: number) => {
    const response = await QlickUpAPI(
      businessId.toString(),
      "deleterule",
      null,
      "workflow",
      QlickupActions.POST,
      { rule_id: ruleId }
    );

    console.log(response);
  };

  const toggleWorkflow = async (businessId: number, workflowId: number) => {
    const response = await QlickUpAPI(
      businessId.toString(),
      "toggleworkflow",
      null,
      "workflow",
      QlickupActions.POST,
      { workflow_id: workflowId }
    );

    console.log(response);
    return response.data;
  };

  return {
    submitNewWorkflow,
    getallWorkFlows,
    getOneWorkFlow,
    sendOrUpdateRuleKanban,
    sendOrUpdateRuleStatus,
    getAllRules,
    deleteWorkFlow,
    deleteRule,
    toggleWorkflow,
  };
};
